import axios from "axios";

export default function updateSlaConfig({
  priority,
  responseHours,
  responseHoursType,
  resolutionHours,
  resolutionHoursType,
}) {
  const body = {};
  if (responseHours !== undefined) body.response_hours = responseHours;
  if (responseHoursType !== undefined) body.response_hours_type = responseHoursType;
  if (resolutionHours !== undefined) body.resolution_hours = resolutionHours;
  if (resolutionHoursType !== undefined) body.resolution_hours_type = resolutionHoursType;
  return new Promise((resolve, reject) =>
    axios
      .put(`/support/api/v1/admin/sla-configs/${priority}`, body)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
